import 'uikit/dist/css/uikit.min.css';
import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n';
import ReadMore from 'vue-read-more';
import FlagIcon from 'vue-flag-icon';

Vue.use(ReadMore);
Vue.use(FlagIcon);

import UIkit from 'uikit/dist/js/uikit-core';
import Icons from 'uikit/dist/js/uikit-icons';

UIkit.use(Icons);
UIkit.container = '#goldfish-manual';

Vue.prototype.$uikit = Vue.prototype.$api_url = process.env.VUE_APP_API;

import Marked from 'marked';

Vue.prototype.$md = {
	render: Marked,
};

Vue.config.productionTip = false;

new Vue({
	i18n,
	render: (h) => h(App),
}).$mount('#goldfish-manual');
